export default __webpack_public_path__ + "static/au-fcc70f6429792bbb52c1f20064db0e83.svg";